/**
 * Created by mh on 2017/5/23.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import JobTableRowComponent from './JobTableRow';

@observer
export default class JobsView extends React.Component {
    render() {
        const { jobs } = this.props;
        return (
            <tbody>
                {jobs.map(job => <JobTableRowComponent job={job} key={job.id} />)}
            </tbody>
        );
    }
}
JobsView.propTypes = {
    jobs: PropTypes.object.isRequired,
};
